import React from 'react';
import moment from "moment";
import { Downloader } from '../../components/fileDownloader/Downloader';
import AudioPlayerCustom from '../../components/audioPlayerCustom/AudioPlayerCustom';
import ImageAttachmentPreview from '../../components/fileDownloader/ImageAttachmentPreview';
import { isImageAttachment } from '../../helpers/attachmentUtils';

export default function MessagesView({ index, item, selectedData, newUSer, colorCode }) {

    const getAudioUrl = (audio) => {
        if (!audio) return null;
        if (audio?.url) return audio.url;
        if (audio?.audio) {
            try {
                return URL.createObjectURL(audio.audio);
            } catch (err) {
                return null;
            }
        }
        return null;
    };

    const FileView = (u, findUser) => {
        return (
            <div className="containerx">
                <div className="avatar-sm me-3 ms-0">
                    <div className="avatar-down">
                        {selectedData?.unique_id == u?.senderID ? (
                            <p style={{ color: `#${colorCode}` }} className="userName">
                                {selectedData?.name ? selectedData?.name : `#[${u?.senderID}]`}
                            </p>
                        ) : (
                            <p className="userName">{findUser?.sudoName}</p>
                        )}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            {isImageAttachment(u?.file) && (
                                <div style={{ marginRight: 10 }}>
                                    <ImageAttachmentPreview file={u?.file} />
                                </div>
                            )}
                            <Downloader file={u?.file} filename={u?.file?.filename} />
                            <p style={{ paddingLeft: 10 }}>{u?.file?.filename}</p>
                            <span className="time-right">
                                {moment(u?.time).format("hh:mm A  DD/MM/YYYY")}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const AudioView = (u, findUser) => {
        const audioUrl = getAudioUrl(u?.audio);
        if (!audioUrl) return null;
        return (
            <div className="containerx">
                <div className="userInfo">
                    {selectedData?.unique_id == u?.senderID ? (
                        <p style={{ color: `#${colorCode}` }} className="userName">
                            {selectedData?.name ? selectedData?.name : `#[${u?.senderID}]`}
                        </p>
                    ) : (
                        <p className="userName">{findUser?.sudoName}</p>
                    )}
                    <span className="time-right">
                        {moment(u?.time).format("hh:mm A  DD/MM/YYYY")}
                    </span>
                </div>
                <div className="history-audio">
                    <AudioPlayerCustom audioUrl={audioUrl} />
                </div>
            </div>
        );
    };
    return (
        <>{item?.type === "joiner" ? (
            <div
                className="containerx"
                key={index}
                style={{
                    width: "100%",
                    fontStyle: "italic",
                    textAlign: "center",
                    lineHeight: "0px",
                    marginBottom: "20px",
                }}
            >
                <p style={{ textAlign: "center" }}>{item?.message}</p>
                <span style={{ fontSize: 10 }}>
                    {moment(item?.time).format("hh:mm A  DD/MM/YYYY")}
                </span>
            </div>
        ) : item?.type === "leave" ? (
            <div
                className="containerx"
                key={index}
                style={{
                    width: "100%",
                    fontStyle: "italic",
                    textAlign: "center",
                    lineHeight: "0px",
                    marginBottom: "20px",
                }}
            >
                <p style={{ textAlign: "center" }}>{item?.message}</p>
                <span style={{ fontSize: 10, textAlign: "center" }}>
                    {moment(item?.time).format("hh:mm A  DD/MM/YYYY")}
                </span>
            </div>
        ) : item?.type === "widget" ? (
            <div
                className="containerx"
                key={index}
                style={{
                    width: "100%",
                    fontStyle: "italic",
                    textAlign: "center",
                    lineHeight: "0px",
                    marginBottom: "20px",
                }}
            >
                <p style={{ textAlign: "center" }}>{item?.message}</p>
                <span style={{ fontSize: 10, textAlign: "center" }}>
                    {moment(item?.time).format("hh:mm A  DD/MM/YYYY")}
                </span>
            </div>
        ) : item?.type === "disconnect" ? (
            <div
                className="containerx"
                key={index}
                style={{
                    width: "100%",
                    fontStyle: "italic",
                    textAlign: "center",
                    lineHeight: "0px",
                    marginBottom: "20px",
                }}
            >
                <p style={{ textAlign: "center" }}>{item?.message}</p>
                <span style={{ fontSize: 10, textAlign: "center" }}>
                    {moment(item?.time).format("hh:mm A  DD/MM/YYYY")}
                </span>
            </div>
        ) : item?.audio ? (
            AudioView(item, newUSer)
        ) : item?.file != null ? (
            FileView(item, newUSer)
        ) : (
            (item?.type === "text" || item?.message) && (
                <div className="containerx" key={index}>
                    <div className="userInfo">
                        {selectedData?.unique_id == item?.senderID ? (
                            <p style={{ color: `#fcae29` }} className="userName">
                                {selectedData?.name
                                    ? selectedData?.name
                                    : `#[${item?.senderID}]`}
                            </p>
                        ) : (
                            <p className="userName">{newUSer?.sudoName}</p>
                        )}
                        <span className="time-right">
                            {moment(item?.time).format("hh:mm A  DD/MM/YYYY")}
                        </span>
                    </div>
                    <p>{item?.message}</p>
                </div>
            )
        )}</>
    )
}
